// NPM imports
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Button, Input } from "@revvsales/components";

import { GRID } from "../../constants";
import ResourceListing from "./ResourceListing";
// Destructuring
const { PRICING_METHODS_LABELS } = GRID;
// Declarations
class PriceControlForBundle extends Component {
  state = {
    data: {},
    total: 0,
  };

  componentDidMount = () => {
    this.setState({
      data: this.props.data,
      total: this._returnListPrice(
        this.props.data.bundles,
        this.props.data.basePrice,
      ),
    });
  };

  _calculateBaseprice = (index, value) => {
    const cloneBundles = [...this.props.data.bundles];
    cloneBundles[index].months = value;
    this.setState({
      data: this.props.data,
      total: this._returnListPrice(cloneBundles, this.props.data.basePrice),
    });
  };

  _returnListPrice = (items, basePrice) =>
    items.reduce((sumValue, item) => sumValue + item.price * item.months, 0) +
    basePrice; // (Price * Months + BasePrice) in a loop

  _disableSubmitBtn = () => this.state.data.bundles.some(item => !item.months);

  _onSubmit = () => {
    const cloneState = JSON.parse(JSON.stringify(this.state.data));
    cloneState.value = this.state.total;
    this.props.onSave(cloneState);
  };

  render() {
    const { type } = this.props.data;
    const {
      data: { basePrice, bundles },
      total,
    } = this.state;
    if (bundles && bundles.length > 0) {
      return (
        <Fragment>
          <section>
            <div className="popup-header">
              {PRICING_METHODS_LABELS[type]} for {this.props.productName}
            </div>
          </section>
          {basePrice > 0 && (
            <section>
              <div className="dealtable-baseprice">
                <div className="pricing-options-matrixtitle">Base Price</div>
                <Input
                  className="pricing-options-input readonly-input form-control"
                  disabled
                  placeholder="Enter Base Price"
                  readOnly
                  value={basePrice}
                />
              </div>
            </section>
          )}
          <section>
            <div className="bundleeditor-subtitle-wrapper">
              <span className="bundleeditor-subtitle is-bundle">Resources</span>
              <span className="bundleeditor-subtitle">Scale</span>
            </div>
            {bundles.map((product, index) => (
              <ResourceListing
                data={product}
                index={index}
                key={product}
                onChange={this._calculateBaseprice}
                readOnly={this.props.isLocked}
                data-test="pricecontrolforbundle-resourcelisting"
              />
            ))}
          </section>
          {!this.props.isLocked && (
            <Fragment>
              <section className="dealtable-pricing-preview">
                <div className="pricing-preview-title">Price Preview</div>
                <div className="pricing-preview-total">
                  Total price for {this.props.productName} is{" "}
                  <b>
                    {this.props.currencySymbol}
                    {(total && total.toFixed(2)) || 0}
                  </b>
                  {/* Need to minus with to handle hanging declimal value i.e 123. */}
                </div>
              </section>
              <section>
                <div className="popup-footer">
                  <div className="addgridcolumn-footer-actions">
                    <Button
                      data-test="price-submit-button"
                      className="btn btn-primary"
                      disabled={this._disableSubmitBtn()}
                      onClick={this._onSubmit}>
                      Submit
                    </Button>
                  </div>
                </div>
              </section>
            </Fragment>
          )}
        </Fragment>
      );
    }
    return null;
  }
}
const mapDispatchToProps = {};

export default connect(
  null,
  mapDispatchToProps,
)(PriceControlForBundle);



// WEBPACK FOOTER //
// ./src/components/AgGridPriceForBundle/PriceControlForBundle.js